import { ApolloProvider } from '@apollo/client';
import { apolloClient, createApolloClient } from 'lib/services';
import { type FC, type PropsWithChildren, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { sessionState } from 'store';

export const AppApolloProvider: FC<PropsWithChildren<object>> = ({ children }) => {
  const [client, setClient] = useState(apolloClient);
  const { jwt } = useRecoilValue(sessionState);

  useEffect(() => {
    setClient(createApolloClient());
  }, [jwt]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
